import React, {useState, useEffect, useCallback} from 'react';
import duckify, { singleDuck, currentCustomer } from '../../utils/duckify';
import { formTemplates } from '../../ducks';
import Placeholder from '../Placeholder';
import { formatDateTime } from '../../utils';
import registerComponent from '../../utils/registeredComponent';

const FormTemplateInfo = ({formTemplate, allDucksReady, toggleFusionLayout}) => <Placeholder.loading ready={allDucksReady} content={() => (
  <div className="card card-body bg-light">
    <div>
      State: {formTemplate.state}
    </div>

    <div>
      Created at: {formatDateTime(formTemplate.created_at)}
    </div>

    {
      currentCustomer.fusion_forms_layout_enabled &&
      (
        <div onClick={() => toggleFusionLayout(formTemplate)}>
          <input type={'checkbox'} checked={formTemplate.fusion_layout}/> Use Fusion Layout
        </div>
      )
    }
  </div>
)}/>;

const mapDucksToProps = ({ template_id }) => ({
  formTemplate: singleDuck(formTemplates, template_id),
  currentCustomer
});

const mapDispatchToProps = (dispatch) => ({
  toggleFusionLayout: (formTemplate) => dispatch(formTemplates.actions.update({...formTemplate, fusion_layout: !formTemplate.fusion_layout}))
    .then(() => location.reload()),
});

const duckified = duckify(mapDucksToProps, () => ({}), mapDispatchToProps)(FormTemplateInfo);

export default registerComponent('FormTemplateInfo')(duckified);
